import { queryRouters } from '@wix/ambassador-document-v1-router/http';
const PAGE_LIMIT = 100;
export const fetchRoutersData = async (httpClient, errorHandler) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allRoutes = [];
  await withErrorHandler(async () => {
    let hasMore = true;
    let cursor;
    do {
      var _metadata$cursors;
      const result = await httpClient.request(queryRouters({
        eventuallyConsistent: false,
        query: {
          cursorPaging: {
            cursor,
            limit: PAGE_LIMIT
          }
        }
      }));
      const {
        routers,
        metadata
      } = result.data;
      allRoutes.push(...(routers ?? []));
      hasMore = (metadata == null ? void 0 : metadata.hasNext) ?? false;
      cursor = (metadata == null || (_metadata$cursors = metadata.cursors) == null ? void 0 : _metadata$cursors.next) ?? undefined;
    } while (hasMore);
    return allRoutes;
  }, {
    errorCodesMap: {}
  });
  return allRoutes;
};
//# sourceMappingURL=fetch-routers-data.js.map